import { clientPortalRequest } from "./clientPortalFetch";

export function listTeamMembers(clientViewId) {
  return clientPortalRequest(`/views/${clientViewId}/team`);
}

export function inviteTeamMember(clientViewId, payload) {
  return clientPortalRequest(`/views/${clientViewId}/team/invite`, {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export function updateTeamMember(clientViewId, clientUserId, payload) {
  return clientPortalRequest(`/views/${clientViewId}/team/${clientUserId}`, {
    method: "PATCH",
    body: JSON.stringify(payload),
  });
}

export function updateTeamMemberStatus(clientViewId, clientUserId, payload) {
  return clientPortalRequest(`/views/${clientViewId}/team/${clientUserId}/status`, {
    method: "PATCH",
    body: JSON.stringify(payload),
  });
}

export function resendTeamInvitation(clientViewId, clientUserId) {
  return clientPortalRequest(`/views/${clientViewId}/team/${clientUserId}/resend-invitation`, {
    method: "POST",
  });
}
